import type { IconProps } from './icons.types';

export function ChevronRightIcon({ size = 16 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 7 12" fill="currentColor" aria-hidden="true">
      <path d="M4.6 5.65375L0 1.05375L1.05375 0L6.7075 5.65375L1.05375 11.3075L0 10.2538L4.6 5.65375Z" />
    </svg>
  );
}
